module.exports = __webpack_public_path__ + "img/installation-1.e5f03b91.png";